import { ApplicationState } from '@app/store'
import {
  actionCreators,
  IGlobalGroupsState,
  selectGroups,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { GroupFilterSelector } from '../components/GroupFilterSelector'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalGroupsState>({
    groups: selectGroups(),
  }),
  actionCreators,
)(GroupFilterSelector)
